var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoAsterisk = function SvgMoAsterisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mo-asterisk_svg__a)",
    fillRule: "evenodd",
    d: "M36.813 0H25.187v16.497L13.065 4.374l-8.22 8.22 12.593 12.594H0v11.625h16.469L4.597 48.684l8.22 8.22 12.37-12.37V62h11.625V44.563l11.872 11.871 8.22-8.22-11.401-11.401H62V25.187H44.534l12.124-12.123-8.22-8.22-11.626 11.625z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo-asterisk_svg__a",
    x1: 8.206,
    x2: 53.338,
    y1: 8.206,
    y2: 53.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgMoAsterisk;